// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"22cd5610","977":"57662203"}[chunkId] + ".chunk.js";
};